import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {ServiceBase} from "../ServiceBase";
import {FreePlaySlideRenderer} from "./video-slides-renderers/free-play-slide.renderer";
import {VideoSlideRenderer} from "./video-slides-renderers/video-slide.renderer";
import {ISlideRenderer, IVideoSlidesService} from "./video-slides.service.interface";

export class VideoSlidesService extends ServiceBase implements IVideoSlidesService {
    constructor(services: IServiceFactoryExtended) {
        super(services);
        let seedLoadedSlides = Array.from({length: 500}).map((_, index) => `Slide ${index + 1}`);
        seedLoadedSlides.forEach(seedSlide => this._pushSlide(seedSlide));
    }

    private _slideList: ISlideRenderer[] = [];
    get slideList(): ISlideRenderer[] {
        return this._slideList;
    }

    private _pushSlide(index: string) {
        //this._slideList.push(new VideoSlideRenderer(index));

        if(Math.random() < 0.5){
            let current = new VideoSlideRenderer(index);
            this._slideList.push(current);
        } else {
            let current = new FreePlaySlideRenderer(index);
            this._slideList.push(current);
        }

    }
}
